import {Button} from '@wandb/weave/components/Button/Button';
import {
  ToggleButtonGroup,
  type ToggleOption,
} from '@wandb/weave/components/ToggleButtonGroup';
import React from 'react';

const CLEAR_BUTTON_OPTION: ToggleOption = {
  value: 'clear',
  icon: 'close',
  iconOnly: true,
  tooltip: 'Clear selection',
};

// This menu appears when you make a selection in a Parallel Coordinates or Scatter Plot
// Menu options: Clear selection, or Convert selection to filters
export const SelectionBoundsMenu: React.FC<{
  clearSelections(): void;
  convertSelectionsToFilters(): void;
}> = ({clearSelections, convertSelectionsToFilters}) => {
  if (convertSelectionsToFilters == null) {
    // ToggleButtonGroup is only for multiple buttons
    return (
      <Button
        icon={CLEAR_BUTTON_OPTION.icon}
        size="small"
        variant="secondary"
        onClick={clearSelections}
        tooltip={CLEAR_BUTTON_OPTION.tooltip}
      />
    );
  }
  return (
    <ToggleButtonGroup
      hideWhenDetached={true}
      options={[
        {
          value: 'convert',
          icon: 'filter-alt',
          iconOnly: true,
          tooltip: 'Create a filter from this selection',
        },
        CLEAR_BUTTON_OPTION,
      ]}
      value="none of them"
      size="small"
      onValueChange={value => {
        if (value === 'convert') {
          convertSelectionsToFilters();
        } else if (value === 'clear') {
          clearSelections();
        }
      }}
    />
  );
};
